// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!/export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-style-loader!/export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/css-loader?sourceMap&-autoprefixer!/export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/style-compiler?{"id":"data-v-1bd07fba","scoped":false,"hasInlineConfig":false}!/export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/selector.js?type=styles&index=0!./client/views/Dashboard.vue
// module id = 1016
// module chunks = 1